/**
 * External dependencies
 */
import has from 'lodash/has';

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Component, Fragment } from '@wordpress/element';
import { ButtonGroup, IconButton, __experimentalUnitControl as UnitControl, BaseControl } from '@wordpress/components';

/**
 * Padding controls
 */
class PaddingControl extends Component {
	constructor( props ) {
		super( props );
		this.updateValues = this.updateValues.bind( this );
		this.state = {
			device: 'desktop',
		};
	}

	updateValues( data ) {
		const { attributes, parentKey, setAttributes, property } = this.props;
		let values = has( attributes, `${ parentKey }.${ property }` ) ? attributes[ parentKey ][ property ] : {};
		values = {
			...values,
			...data,
		};

		const options = {
			...attributes[ parentKey ],
			[ property ]: { ...values },
		};

		setAttributes( { [ parentKey ]: { ...options } } );

		this.props.onChange( { [ parentKey ]: { ...options } } );
	}

	render() {
		const { attributes, parentKey, label, property, id, help, disabled = false } = this.props;
		const values = has( attributes, `${ parentKey }.${ property }` ) ? attributes[ parentKey ][ property ] : '';
		const desktop = has( values, `desktop` ) ? values.desktop : {};
		const tablet = has( values, `tablet` ) ? values.tablet : {};
		const mobile = has( values, `mobile` ) ? values.mobile : {};

		const units = [
			{ value: 'px', label: 'px', default: '' },
			{ value: '%', label: '%', default: '' },
			{ value: 'em', label: 'em', default: '' },
		];
		return <div className="padding-control-wrapper">
			<BaseControl
				label={ label }
				id={ id }
				help={ help }
			>
				<div className="padding-actions-area">
					{ /* <ButtonGroup>
					<Button isPrimary={ '%' === unit } onClick={ () => {
						this.updateValues( { unit: '%' } );
					} }>%</Button>
					<Button isPrimary={ 'px' === unit } onClick={ () => {
						this.updateValues( { unit: 'px' } );
					} }>PX</Button>
				</ButtonGroup> */ }
					<ButtonGroup>
						<IconButton
							disabled={ disabled }
							icon="desktop"
							label={ __( 'Desktop' ) }
							isPrimary={ 'desktop' === this.state.device }
							onClick={ () => {
								this.setState( {
									device: 'desktop',
								} );
							} }
						/>
						<IconButton
							disabled={ disabled }
							icon="tablet"
							label={ __( 'Tablet' ) }
							isPrimary={ 'tablet' === this.state.device }
							onClick={ () => {
								this.setState( {
									device: 'tablet',
								} );
							} }
						/>
						<IconButton
							disabled={ disabled }
							icon="smartphone"
							label={ __( 'Mobile' ) }
							isPrimary={ 'mobile' === this.state.device }
							onClick={ () => {
								this.setState( {
									device: 'mobile',
								} );
							} }
						/>
					</ButtonGroup>
				</div>
				<div className="padding-fields-area">
					{ 'desktop' === this.state.device && <Fragment>
						<UnitControl
							disabled={ disabled }
							label={ __( 'Top' ) }
							value={ desktop.top }
							onChange={ ( value ) => {
								const _padding = {
									...desktop,
									...{ top: value },
								};
								this.updateValues( { desktop: _padding } );
							} } units={ units } />
						<UnitControl
							disabled={ disabled }
							label={ __( 'Right' ) }
							value={ desktop.right }
							onChange={ ( value ) => {
								const _padding = {
									...desktop,
									...{ right: value },
								};
								this.updateValues( { desktop: _padding } );
							} } units={ units } />
						<UnitControl
							disabled={ disabled }
							label={ __( 'Bottom' ) }
							value={ desktop.bottom }
							onChange={ ( value ) => {
								const _padding = {
									...desktop,
									...{ bottom: value },
								};
								this.updateValues( { desktop: _padding } );
							} } units={ units } />
						<UnitControl
							disabled={ disabled }
							label={ __( 'Left' ) }
							value={ desktop.left }
							onChange={ ( value ) => {
								const _padding = {
									...desktop,
									...{ left: value },
								};
								this.updateValues( { desktop: _padding } );
							} } units={ units } />
					</Fragment>
					}
					{ 'tablet' === this.state.device && <Fragment>
						<UnitControl
							disabled={ disabled }
							label={ __( 'Top' ) }
							value={ tablet.top }
							onChange={ ( value ) => {
								const _padding = {
									...tablet,
									...{ top: value },
								};
								this.updateValues( { tablet: _padding } );
							} } units={ units } />
						<UnitControl
							disabled={ disabled }
							label={ __( 'Right' ) }
							value={ tablet.right }
							onChange={ ( value ) => {
								const _padding = {
									...tablet,
									...{ right: value },
								};
								this.updateValues( { tablet: _padding } );
							} } units={ units } />
						<UnitControl
							disabled={ disabled }
							label={ __( 'Bottom' ) }
							value={ tablet.bottom }
							onChange={ ( value ) => {
								const _padding = {
									...tablet,
									...{ bottom: value },
								};
								this.updateValues( { tablet: _padding } );
							} } units={ units } />
						<UnitControl
							disabled={ disabled }
							label={ __( 'Left' ) }
							value={ tablet.left }
							onChange={ ( value ) => {
								const _padding = {
									...tablet,
									...{ left: value },
								};
								this.updateValues( { tablet: _padding } );
							} } units={ units } />
					</Fragment>
					}
					{ 'mobile' === this.state.device && <Fragment>
						<UnitControl
							disabled={ disabled }
							label={ __( 'Top' ) }
							value={ mobile.top }
							onChange={ ( value ) => {
								const _padding = {
									...mobile,
									...{ top: value },
								};
								this.updateValues( { mobile: _padding } );
							} } units={ units } />
						<UnitControl
							disabled={ disabled }
							label={ __( 'Right' ) }
							value={ mobile.right }
							onChange={ ( value ) => {
								const _padding = {
									...mobile,
									...{ right: value },
								};
								this.updateValues( { mobile: _padding } );
							} } units={ units } />
						<UnitControl
							disabled={ disabled }
							label={ __( 'Bottom' ) }
							value={ mobile.bottom }
							onChange={ ( value ) => {
								const _padding = {
									...mobile,
									...{ bottom: value },
								};
								this.updateValues( { mobile: _padding } );
							} } units={ units } />
						<UnitControl
							disabled={ disabled }
							label={ __( 'Left' ) }
							value={ mobile.left }
							onChange={ ( value ) => {
								const _padding = {
									...mobile,
									...{ left: value },
								};
								this.updateValues( { mobile: _padding } );
							} } units={ units } />
					</Fragment>
					}
				</div>
			</BaseControl>
		</div>;
	}
}

export default PaddingControl;
